import type { FC } from "react";
import { PageMargins } from "../components/global";
import { _01Hero } from "../components/pages/home/_01Hero/_01Hero";
import { _02ATitle } from "../components/pages/home/_02About/_02ATitle";
import { _02BBody } from "../components/pages/home/_02About/_02BBody";
import { _02CCallToAction } from "../components/pages/home/_02About/_02CCallToAction";
import { _03Testimonial } from "../components/pages/home/_03Testimonial/_03Testimonial";
import { _04ATitle } from "../components/pages/home/_04Examples/_04ATitle";
import { _04BBody } from "../components/pages/home/_04Examples/_04BBody";
import { _04CCTA } from "../components/pages/home/_04Examples/_04CCTA";
import { _05Testimonial } from "../components/pages/home/_05Testimonial/_05Testimonial";
import { _06ATitle } from "../components/pages/home/_06Packages/_06ATitle";
import { _06BBody } from "../components/pages/home/_06Packages/_06BBody";
import { _06CCTA } from "../components/pages/home/_06Packages/_06CCTA";
import { _07Testimonial } from "../components/pages/home/_07Testimonial/_07Testimonial";
import { _08ATitle } from "../components/pages/home/_08Gallery/_08ATitle";
import { _08BBody } from "../components/pages/home/_08Gallery/_08BBody";
import { _08CCTA } from "../components/pages/home/_08Gallery/_08CCTA";
import { _09Coverage } from "../components/pages/home/_09Coverage/_09Coverage";
import { _10ATitle } from "../components/pages/home/_10Contact/_10ATitle";
import { _10BBody } from "../components/pages/home/_10Contact/_10BBody";
import { _10CCTA } from "../components/pages/home/_10Contact/_10CCTA";
import { Layout } from "../layout/layout";

export interface HomeProps {
  className?: string;
}

export const Home: FC<HomeProps> = ({ className = "" }) => {
  return (
    <Layout>
      <PageMargins show={false}>
        <div className={`w-full overflow-x-hidden ${className}`} style={{ width: '100%', maxWidth: '100vw' }}>
          <_01Hero />
          <_02ATitle />
          <_02BBody />
          <_02CCallToAction />
          <_03Testimonial />
          <_04ATitle />
          <_04BBody />
          <_04CCTA />
          <_05Testimonial />
          <_06ATitle />
          <_06BBody />
          <_06CCTA />
          <_07Testimonial />
          <_08ATitle />
          <_08BBody />
          <_08CCTA />
          <_09Coverage />
          <_10ATitle />
          <_10BBody />
          <_10CCTA />
        </div>
      </PageMargins>
    </Layout>
  );
};

export default Home;
